import { render, staticRenderFns } from "./HomeEn.vue?vue&type=template&id=a24c0d54&scoped=true"
import script from "./HomeEn.vue?vue&type=script&lang=js"
export * from "./HomeEn.vue?vue&type=script&lang=js"
import style0 from "./HomeEn.vue?vue&type=style&index=0&id=a24c0d54&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24c0d54",
  null
  
)

export default component.exports